import { render } from "./prefill-forms-consent-modal.vue?vue&type=template&id=c7c1f2aa&scoped=true"
import script from "./prefill-forms-consent-modal.vue?vue&type=script&lang=js"
export * from "./prefill-forms-consent-modal.vue?vue&type=script&lang=js"

import "./prefill-forms-consent-modal.vue?vue&type=style&index=0&id=c7c1f2aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c1f2aa"]])

export default __exports__